const KONG_SERVICE_NAME_ANNOTATION = "kong-manager/service-name";
const KONG_SERVICE_INSTANCE_ANNOTATION = "kong-manager/instance";
const KONG_SERVICE_SPEC_ANNOTATION = "kong-manager/spec";

export { KONG_SERVICE_INSTANCE_ANNOTATION, KONG_SERVICE_NAME_ANNOTATION, KONG_SERVICE_SPEC_ANNOTATION };
//# sourceMappingURL=kongAnnotations.esm.js.map
